import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const MasterListContent = lazy(() => import('./MasterListContent'));



const MasterList = () => {
    return (
        <Suspense fallback={<DefaultLoader />}>
            <MasterListContent />
        </Suspense>
    );
};

export default MasterList;